import { createFileRoute } from "@tanstack/react-router";
import { seo } from "@/lib/seo";
import Admin from "@/pages/Admin";

export const Route = createFileRoute("/admin")({
  head: () => ({
    ...seo({
      title: "Admin | Kodiak Structures & Exteriors",
      path: "/admin",
      noindex: true,
    }),
  }),
  component: Admin,
});
